// src/config/env.js
const config = {
    development: {
      apiUrl: 'http://localhost:3001',
    },
    test: {
      apiUrl: 'https://api.sellertool.cn',//'https://api.temu-assistant.cn',
    },
    production: {
      apiUrl: 'https://api.sellertool.cn',
    },
  };
  
  export default config[process.env.NODE_ENV || 'development'];